import * as React from "react";

export const SvgFacebook = (props) => (
	<svg width={39} height={38} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M19.5.5C29.717.5 38 8.783 38 19s-8.283 18.5-18.5 18.5S1 29.217 1 19 9.283.5 19.5.5Z"
			stroke="#FFB11A"
		/>
		<path
			d="m23.498 11.489-1.966-.004c-2.209 0-3.637 1.465-3.637 3.732v1.72h-1.977a.31.31 0 0 0-.309.31v2.493c0 .17.139.309.31.309h1.976v6.29c0 .171.139.31.31.31h2.58a.31.31 0 0 0 .308-.31v-6.29h2.312a.31.31 0 0 0 .31-.31v-2.492a.31.31 0 0 0-.31-.31h-2.312V15.48c0-.701.167-1.057 1.08-1.057h1.325a.31.31 0 0 0 .31-.31v-2.314a.31.31 0 0 0-.31-.31Z"
			fill="#FFB11A"
		/>
	</svg>
);
